<script lang="ts" setup>
  import { loadWithStatusAndErrorHandleAsync } from '@/services/loading-svc.ts';
  import { useApprovalStore } from '@/stores/approval.ts';
  import { useAuthStore } from '@/stores/auth.ts';
  import { useThemeStore } from '@/stores/theme';
  import { ForwardIcon } from '@heroicons/vue/20/solid';
  import { onMounted, ref } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();
  const authStore = useAuthStore();
  const approvalStore = useApprovalStore();
  const themeStore = useThemeStore();

  const pendingApplicationCnt = ref<number>(0);

  async function refreshAsync() {
    if (!authStore.isManager) return;
    await loadWithStatusAndErrorHandleAsync(
      (_) => {},
      async () => {
        const items = await approvalStore.getMyPendingApprovalApplications();
        pendingApplicationCnt.value = items.length;
      }
    );
  }

  onMounted(() => {
    refreshAsync();
  });
</script>

<template>
  <DefaultLayout title="결재/신청">
    <div
      class="w-full border shadow-sm card bg-base-100"
      :class="{
        'border-slate-700 bg-neutral': themeStore.isDark,
      }">
      <div class="p-5 card-body gap-4">
        <div
          v-if="authStore.isOrigin"
          class="flex items-center">
          <p>나의 신청 목록</p>
          <button
            class="btn btn-secondary btn-circle btn-sm btn-outline"
            @click="router.push({ name: 'ApprovalRequestBox' })">
            <ForwardIcon class="w-4 h-4" />
          </button>
        </div>

        <div
          v-if="authStore.isManager"
          class="flex items-center">
          <p>
            승인할 신청서 목록
            <span
              v-if="pendingApplicationCnt != 0"
              class="ml-1 font-bold badge badge-secondary text-white">
              {{ pendingApplicationCnt }} 개
            </span>
          </p>
          <button
            class="btn btn-secondary btn-circle btn-sm btn-outline"
            @click="router.push({ name: 'ApprovalPendingBox' })">
            <ForwardIcon class="w-4 h-4" />
          </button>
        </div>

        <div
          v-if="authStore.isManager"
          class="flex items-center">
          <p>완료된 신청서 목록</p>
          <button
            class="btn btn-secondary btn-circle btn-sm btn-outline"
            @click="router.push({ name: 'ApprovalConfirmBox' })">
            <ForwardIcon class="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <button
        v-if="authStore.isOrigin"
        class="text-base btn btn-block btn-primary"
        @click="router.push({ name: 'ApprovalRequest' })">
        근태 신청
      </button>
    </div>
  </DefaultLayout>
</template>
